import React, { useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 0em 0;
  margin-bottom: 1em;
  border-bottom: solid 2px #ddd;
`;

interface Props {
  active: any;
  onClick: (value: any) => void;
}

const Tabs: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const [tab, setTab] = useState(props.active);

  const handleTabClick = (tab: any) => {
    let changed = tab.props.value !== tab ? true : false;
    setTab(tab.props.value);
    props.onClick(tab.props.value);
  };

  let tabs = React.Children.toArray(props.children);
  tabs.map((t: any, idx) => {
    let isActive = false;
    if (t.props.value === tab) {
      isActive = true;
    }

    tabs[idx] = React.cloneElement(t, {
      isActive: isActive,
      onClick: () => {
        handleTabClick(t);
      },
    });
  });

  return <Wrapper>{tabs}</Wrapper>;
};

export default Tabs;
